export const getCurrencyString = (
  currency: string,
  amount: number | string
) => {
  return `${currency.toUpperCase()} ${amount}`;
};